module.exports = __webpack_public_path__ + "img/logo-icon.40a3c062.svg";